'use client';
import React from 'react';
export const CheckboxGroupContext = /*#__PURE__*/React.createContext(void 0);